//-- showing the updated placeholder massage ---//
setContent('int',{"country":"IN"});

  //------for close button of banner welcome message------//
  $(document).on('click','.welcome-msg-close',function(){
      $('.headlinee').fadeOut();
      localStorage.setItem('welcome-msg-close-status', 1);
  });

  
  // if( 1 != 1 && getCookie("cc") && getCookie("response") ){
  //   console.log('is in cookie');
  //   var cc = getCookie("cc");
  //   var response = JSON.parse( getCookie("response") );
  //   setContent(cc,response);
  // } else {
  //   var ip = '';
  //   $.getJSON("https://api.ipify.org/?format=json", function(e) {
  //       ip = e.ip;
  //       var urlParams = new URLSearchParams(window.location.search);
  //       // searching for ip query param
  //       if (urlParams.has('ip')) { 
  //         ip = urlParams.get('ip');
  //       }
  //       if((ip != '')){
  //         console.log('The ip is:' + ip);
  //         $.getJSON('https://ipapi.co/' + ip + '/json', function(response){
  //             if(isDomainList(response.country) >= 0){
  //               console.log('is domain');
  //               setContent(response.country.toLowerCase(),response);
  //             }else{
  //               console.log('not is domain', response);
  //               setContent('int',response);
  //             }
  //         });
  //       }else{
  //         $('.headline').html($('.headlineval').val());
  //       }
  //   });
  // } 

//--- for showing welcom popup ---//
$(document).on('click','#poptin-signup-welcome',function(){
  
      //--- updated ----//
      if($(window).width()>760){
        
        if( window.location.href.indexOf('es.') != -1 ){
        	poptin_display('26e9496c29131');
          
        } else if (window.location.href.indexOf('ca.') != -1){
        	poptin_display('5779fa5570612');
          
        } else if ( window.location.href.indexOf('au.') != -1 ){
          	poptin_display('f75a6dab4133c');
          
        } else if (window.location.href.indexOf('cz.') != -1){
            poptin_display('b61533c420f31');

        } else if(window.location.href.indexOf('pl.') != -1){
           poptin_display('c68386b168f5b');

        } else if(window.location.href.indexOf('pt.') != -1){
            poptin_display('a5c5323e901a6');

        } else if(window.location.href.indexOf('th.') != -1){
             poptin_display('434063ac01598');
          
        } else if(window.location.href.indexOf('ru.') != -1){
            poptin_display('91c151ed646f5');
          
        } else if(window.location.href.indexOf('ko.') != -1){
             poptin_display('ed986d17405f2');
          
        } else if(window.location.href.indexOf('ar.') != -1){
              poptin_display('6ddd311639578');
          
        } else if(window.location.href.indexOf('el.') != -1){
              poptin_display('d58136b0d6158');
          
        } else if(window.location.href.indexOf('ja.') != -1){
              poptin_display('6d0d8e4d455f1');
          
        } else if(window.location.href.indexOf('zh.') != -1){
           poptin_display('9103eda015136');

        } else if(window.location.href.indexOf('de.') != -1){
           poptin_display('3119d345cdfd6');
          
        } else if(window.location.href.indexOf('it.') != -1){
              poptin_display('15955311f96cd');
          
        } else if(window.location.href.indexOf('nl.') != -1){
              poptin_display('1f50d58928691');
          
        } else {
        	poptin_display('26e9496c29131');
        }
    
        console.log('desktop pop triggered');
         
      }else{
        
        if( window.location.href.indexOf('cz.') != -1 ){
        	poptin_display('a26d7f66752dd');
          
        } else if( window.location.href.indexOf('pl.') != -1 ){
        	poptin_display('4022baf215665');
          
        } else if( window.location.href.indexOf('pt.') != -1 ){
        	poptin_display('54b6fdf2b9a6d');

        } else if( window.location.href.indexOf('th.') != -1 ){
            poptin_display('2ff535bcf9b65');

        } else if ( window.location.href.indexOf('ru.') != -1 ){
          poptin_display('fd012fbe22956');

        } else if ( window.location.href.indexOf('ko.') != -1 ){
          poptin_display('26254fcccb20d');

        } else if( window.location.href.indexOf('ar.') != -1 ){
          poptin_display('25c4ff5e8a5b6');

        } else if( window.location.href.indexOf('el.') != -1 ){
          poptin_display('2b7ece96f4f6a');

        } else if( window.location.href.indexOf('ja.') != -1 ){
          poptin_display('6f1f6c21787a9');

        } else if( window.location.href.indexOf('zh.') != -1 ){
          poptin_display('6529a7fcf495d');

        } else if( window.location.href.indexOf('de.') != -1 ){
          poptin_display('cbac68a0c23ff');

        } else if( window.location.href.indexOf('it.') != -1 ){
          poptin_display('0d2f2cafa1b69');

        } else if( window.location.href.indexOf('nl.') != -1 ){
          poptin_display('ec812eaff2650');

        } else if( window.location.href.indexOf('es.') != -1 ){
          poptin_display('62fa4322470e4');

        } else if( window.location.href.indexOf('.fr') != -1 ){
          poptin_display('d1a624ed35f1e');

        } else {
        	poptin_display('62fa4322470e4');
        }
        console.log('mobile pop triggered');
      }
  
  // if($(window).width()>760){
  //   poptin_display('96cf210a42212');
  //   console.log('desktop-pop-trigger');
  // }else{
  //   poptin_display('f616c9a1157f2');    
  //   console.log('mobile-pop-trigger');  
  // }  
           
});


function setContent(cc,response){
   
   //console.log('The cc is:' + cc);
  //console.log('The response is:' + response);
  
   if((cc == 'au') && (window.location.href.indexOf('aud.') != -1 || window.location.href.indexOf('au.') != -1)){
        changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
   }else if(window.location.href.indexOf(cc + '.') != -1){
     //---if country code from ip which is cc and url has same countrycode at first like cc.bathmatedirect.com then showing placeholder content--//
        changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
   }else{
     //-- WHEN CLIENT NEEDS THE IP FUNCTIONALITY, WE WILL REMOVE THIS ONE --//
     	changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
     
     //-- CLIENT ASKED TO NOT USE THIS IP FUNCION NEEDS ONLY PLACEHOLDER MESSEGE --//
//        changeLanguageWelcomeMessage(response.country);
//        switch(cc) {
//          case 'gb':
//            cc = 'uk';
//            break;
//          case 'gr':
//            cc = 'el';
//            break;
//          case 'jp':
//            cc = 'ja';
//            break;
//          case 'cn':
//            cc = 'zh';
//            break;
//          case 'kp':
//          case 'kr':
//            cc = 'ko';
//            break;
//          default:
//            // code block
//        }
//		  var currencySymbol = matchCurrency(response.currency);
//        $('.visit').attr('href','https://' + cc + '.bathmatedirect.com').text(cc + '.bathmatedirect.com');
//        $('.currencyContent').text(response.currency+' ('+currencySymbol+')');
//        $('.welcome-banner').css('display','block');
     }
  
     if((localStorage.getItem('welcome-msg-close-status')) && (localStorage.getItem('welcome-msg-close-status') == 1)){
       $('.headlinee').fadeOut();
     }else{ setTimeout(function(){ $('.headlinee').fadeIn(); }, 1000); }
      setCookie("cc", cc, 30);
      setCookie("response", JSON.stringify(response), 30);
}
         
  
// function isEU(countrycode) {
//   var eu_countrycodes = new Array(
//   'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL',
//   'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
//   'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK','GR','JP','CN'
//   );
//   return($.inArray(countrycode, eu_countrycodes));
// }
  
function isDomainList(countrycode) {
  console.log('countrycode',countrycode);
  var domain_list_countrycodes = new Array(
  'UK','GB','US','CA','AU','EU','IL','NO','EL','FI','DK','SE','IS',
  'ES','CZ','PL','PT','RU','TH','KO','KP','KR','AR','EL','JA','ZH','FR','DE',
  'IT','NL','GR','JP','CN'
  );
  return($.inArray(countrycode, domain_list_countrycodes));
}
  
// function matchCurrency(CurrencyCode){
//   var currencyCode = $.trim(CurrencyCode);
//    //var domain_list_countryCodes = {AED: "", AFN: "", ALL: "Lek", ANG: "ƒ", AOA: "", ARS: "$", AUD: "$", AWG: "ƒ", AZN: "ман", BAM: "KM", BBD: "$", BDT: "", BGN: "лв", BHD: "", BIF: "", BMD: "$", BND: "$", BOB: "$b", BRL: "R$", BSD: "$", BWP: "P", BYR: "p.", BZD: "BZ$", CAD: "$", CDF: "", CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "₱", CVE: "", CZK: "Kč", DJF: "", DKK: "kr", DOP: "RD$", DZD: "", EEK: "", EGP: "£", ERN: "", ETB: "", EUR: "€", FJD: "$", FKP: "£", GBP: "£", GEL: "", GHS: "", GIP: "£", GMD: "", GNF: "", GTQ: "Q", GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HTG: "", HUF: "Ft", IDR: "Rp", ILS: "₪", INR: "₹", IQD: "", IRR: "", ISK: "kr", JMD: "J$", JOD: "", JPY: "¥", KES: "", KGS: "лв", KHR: "៛", KMF: "", KPW: "₩", KRW: "₩", KWD: "", KYD: "$", KZT: "лв", LAK: "₭", LBP: "£", LKR: "₨", LRD: "$", LTL: "Lt", LVL: "Ls", LYD: "", MAD: "", MDL: "", MGA: "", MKD: "ден", MMK: "", MNT: "₮", MOP: "", MRO: "", MUR: "₨", MVR: "", MWK: "", MXN: "$", MYR: "RM", MZN: "MT", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", PAB: "B/.", PEN: "S/.", PHP: "Php", PKR: "₨", PLN: "zł", PYG: "Gs", RON: "lei", RSD: "Дин.", RUB: "руб", SBD: "$", SCR: "₨", SEK: "kr", SGD: "$", SHP: "£", SOS: "S", SRD: "$", SVC: "$", SYP: "£", THB: "฿", TRY: "TL", TTD: "TT$", TWD: "NT$", UAH: "₴", USD: "$", UYU: "$U", UZS: "лв", VEF: "Bs", VND: "₫", XCD: "$", ZAR: "R"};
//   var domain_list_countryCodes = {ALL: "Lek", ANG: "ƒ", ARS: "$", AUD: "$", AWG: "ƒ", AZN: "ман", BAM: "KM", BBD: "$", BDT: "৳", BGN: "лв", BIF: "FBu", BMD: "$", BND: "$", BOB: "$b", BRL: "R$", BSD: "$", BWP: "P", BYR: "p.", BZD: "BZ$", CAD: "$", CDF: "FC", CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "₱", CVE: "$", CZK: "Kč", DJF: "Fdj", DKK: "kr", DOP: "RD$", EEK: "kr", EGP: "£", ERN: "Nfk", ETB: "Br", EUR: "€", FJD: "$", FKP: "£", GBP: "£", GEL: "ლ", GHS: "GH₵", GIP: "£", GMD: "D", GNF: "FG", GTQ: "Q", GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HUF: "Ft", IDR: "Rp", ILS: "₪", INR: "₹", ISK: "kr", JMD: "J$", JPY: "¥", KES: "/-", KGS: "лв", KHR: "៛", KPW: "₩", KRW: "₩", KWD: "KD", KYD: "$", KZT: "лв", LAK: "₭", LBP: "£", LKR: "₨", LRD: "$", LTL: "Lt", LVL: "Ls", MKD: "ден", MNT: "₮", MUR: "₨", MXN: "$", MYR: "RM", MZN: "MT", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", PAB: "B/.", PEN: "S/.", PHP: "Php", PKR: "₨", PLN: "zł", PYG: "Gs", RON: "lei", RSD: "Дин.", RUB: "руб", SBD: "$", SCR: "₨", SEK: "kr", SGD: "$", SHP: "£", SOS: "S", SRD: "$", SVC: "$", SYP: "£", THB: "฿", TRY: "TL", TTD: "TT$", TWD: "NT$", UAH: "₴", USD: "$", UYU: "$U", UZS: "лв", VEF: "Bs", VND: "₫", XCD: "$", ZAR: "R"};
//   if(domain_list_countryCodes. hasOwnProperty(currencyCode)){
//     return domain_list_countryCodes[currencyCode];
//   }
//   else{
//     return ' ';
//   }
// //   console.log('USD',domain_list_countrycodes.USD);
// }
  
 function setCookie(cname,cvalue,exdays) {
   var d = new Date();
   d.setTime(d.getTime() + (exdays*24*60*60*1000));
   var expires = "expires=" + d.toGMTString();
   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
 }
  
 function getCookie(cname) {
   var name = cname + "=";
   var decodedCookie = decodeURIComponent(document.cookie);
   var ca = decodedCookie.split(';');
   for(var i = 0; i < ca.length; i++) {
     var c = ca[i];
     while (c.charAt(0) == ' ') {
       c = c.substring(1);
     }
     if (c.indexOf(name) == 0) {
       return c.substring(name.length, c.length);
     }
   }
   return "";
 }
  
// function changeLanguageWelcomeMessage(countryCode){
//   console.log('in changeLanguageWelcomeMessage'+ countryCode);
//   var countryCode = $.trim(countryCode);
//   var lang_list_countryCodes = {
//     FR: "Cliquez ici pour visiter urlXXXX pour voir les options de livraison à votre emplacement et les options de paiement dans curXXXX",
//     SE: "Klicka här för att besöka urlXXXX för att se leveransalternativ till din plats och betalningsalternativ i curXXXX"
//   };
//   if(lang_list_countryCodes.hasOwnProperty(countryCode)){
//     var bannerContent = lang_list_countryCodes[countryCode];
//   }
//   else{
//     var bannerContent = "Click here to visit urlXXXX to see shipping options to your location and payment options in curXXXX";
//   }
//    bannerContent = bannerContent.replace("urlXXXX", "<u><a class='visit' href=''></a></u>");
//    bannerContent = bannerContent.replace("curXXXX", "<span class='currencyContent'></span>");
//    //console.log('bannerContent: '+bannerContent);
//    $('.welcome-banner').html(bannerContent + '<div class="welcome-msg-close"></div>');
//    return;
// }
  
function changeLanguagePlaceholderMessage(countryCode){
  //console.log('in changeLanguagePlaceholderMessage' + countryCode);
  var countryCode = $.trim(countryCode);
  
  var sub_domain = window.location.host;
  sub_domain = sub_domain.split('.')[0];
  
  var subdomainRespectiveLangChange = {
    es: 'Únase a nuestra lista de correo para una oferta de bienvenida exclusiva - <span id="poptin-signup-welcome"><u style="cursor : pointer">Regístrate ahora.</u></span>',
    cz: 'Připojte se k našemu seznamu adresátů a získejte exkluzivní uvítací nabídku - <span id="poptin-signup-welcome"><u style="cursor : pointer">Zaregistrujte se.</u></span>',
    pl: 'Dołącz do naszej listy mailingowej, aby uzyskać ekskluzywną ofertę powitalną - <span id="poptin-signup-welcome"><u style="cursor : pointer">Zapisz się teraz.</u></span>',
    pt: 'Junte-se à nossa lista de e-mails para uma oferta exclusiva de boas-vindas - <span id="poptin-signup-welcome"><u style="cursor : pointer">Inscreva-se agora.</u></span>',
    th: 'เข้าร่วมรายชื่อผู้รับจดหมายของเราเพื่อรับข้อเสนอต้อนรับสุดพิเศษ - <span id="poptin-signup-welcome"><u style="cursor : pointer">สมัครเลย.</u></span>',
    ru: 'Присоединяйтесь к нашему списку рассылки для получения эксклюзивного приветственного предложения - <span id="poptin-signup-welcome"><u style="cursor : pointer">Зарегистрироваться сейчас.</u></span>',
    ko: '독점적 인 환영 제안을 위해 메일 링리스트에 가입하십시오 - <span id="poptin-signup-welcome"><u style="cursor : pointer">지금 등록하세요.</u></span>',
    ar: 'انضم إلى قائمتنا البريدية للحصول على عرض ترحيبي حصري - <span id="poptin-signup-welcome"><u style="cursor : pointer">أفتح حساب الأن.</u></span>',
    el: 'Εγγραφείτε στη λίστα αλληλογραφίας μας για μια αποκλειστική προσφορά καλωσορίσματος - <span id="poptin-signup-welcome"><u style="cursor : pointer">Εγγραφείτε τώρα.</u></span>',
    ja: 'メーリングリストに参加して、特別なウェルカムオファーを受け取りましょう - <span id="poptin-signup-welcome"><u style="cursor : pointer">今すぐサインアップしてください。</u></span>',
    zh: '加入我们的邮件列表以获得独家欢迎优惠 - <span id="poptin-signup-welcome"><u style="cursor : pointer">立即注册。</u></span>',
    de: 'Treten Sie unserer Mailingliste für ein exklusives Willkommensangebot bei - <span id="poptin-signup-welcome"><u style="cursor : pointer">Jetzt registrieren.</u></span>',
    it: 'Iscriviti alla nostra mailing list per un`esclusiva offerta di benvenuto - <span id="poptin-signup-welcome"><u style="cursor : pointer">Iscriviti ora.</u></span>',
    nl: 'Word lid van onze mailinglijst voor een exclusieve welkomstaanbieding - <span id="poptin-signup-welcome"><u style="cursor : pointer">Meld u nu aan.</u></span>',
  };
   if(subdomainRespectiveLangChange.hasOwnProperty(sub_domain)){
     
      var placeholderContent = subdomainRespectiveLangChange[sub_domain];
    }  else{
        var placeholderContent = 'Join Our Mailing List For An Exclusive Welcome Offer - <span id="poptin-signup-welcome"><u style="cursor : pointer">Sign Up Now.</u></span>';
    }
  $('.placeholdercont').html(placeholderContent + '<div class="welcome-msg-close"></div>');
  return;
}